import {
  GET_VERTICAL_GLOBAL_MERTICES,
  GET_VERTICAL_GLOBAL_MERTICES_SUCCESS,
  GET_VERTICAL_GLOBAL_MERTICES_ERROR,
  GET_VERTICAL_GLOBAL_MERTICES_EMPTY,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVerticalGlobalMetrices = (state = initialState, action) => {
  switch (action.type) {
    case GET_VERTICAL_GLOBAL_MERTICES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VERTICAL_GLOBAL_MERTICES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VERTICAL_GLOBAL_MERTICES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VERTICAL_GLOBAL_MERTICES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVerticalGlobalMetrices;
